/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterTag = new PostFilter(
  [['id', PostFilterComparison.eq]],
  'tags',
);

export const PostFilterTagNull = new PostFilter(
  [['guid', PostFilterComparison.null]],
  'tags',
);
